<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-bold" style="color: #54c392">
              <marquee>ຍິນດີຕ້ອນຮັບລະບົບຈັດການການເງິນ</marquee>
            </h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link>ໜ້າຫຼັກ</router-link>
              </li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->
    <!-- test github -->
    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <!-- Small boxes (Stat box) -->
        <div class="row">
          <div class="col-md-8">
            <div
              class="card date-filter-card"
              style="background-color: #54c392"
            >
              <div class="card-body text-white">
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group mb-3">
                      <label for="startDate" class="form-label"
                        >ວັນທີ່ເລີ່ມຕົ້ນ</label
                      >
                      <input
                        type="date"
                        id="startDate"
                        class="form-control datepicker"
                        v-model="startDate"
                      />
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group mb-3">
                      <label for="endDate" class="form-label"
                        >ວັນທີ່ສີ້ນສຸດ</label
                      >
                      <input
                        type="date"
                        id="endDate"
                        class="form-control datepicker"
                        v-model="endDate"
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <label for="endDate" class="form-label"></label>
                    <div class="form-group mb-3 mt-2">
                      <button class="btn btn-light w-100" @click="handleSearch">
                        <i class="fas fa-search me-1"></i> ຄົ້ນຫາ
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3 col-6">
            <div class="small-box income-box-pro bg-none">
              <div
                class="rounded-top w-100 py-1"
                style="background-color: #54c392"
              ></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_incomes) }} ₭</h5>
                <p>ລາຍຮັບທັງໝົດ</p>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-3 col-6">

            <div class="small-box income-box-pro bg-none">
              <div class="bg-primary rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_income_by_mom_s) }} ₭</h5>
                <p>ແມ່ເອົາໃຫ້ທັງໝົດ</p>
              </div>
            </div>
          </div> -->
          <div class="col-lg-3 col-6">
            <div class="small-box income-box-pro bg-none">
              <div class="bg-warning rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_expenditures) }} ₭</h5>
                <p>ລາຍຈ່າຍທັງໝົດ</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6">
            <div class="small-box income-box-pro bg-none">
              <div class="bg-info rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_money_remainings) }} ₭</h5>
                <p>ເງິນທີ່ຍັງເຫຼືອ</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6">
            <div class="small-box income-box-pro bg-none">
              <div class="bg-info rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">$</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_money_remaining_dollars) }} $</h5>
                <p>ເງິນທີ່ຍັງເຫຼືອ</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6">
            <div class="small-box income-box-pro bg-none">
              <div class="bg-danger rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_expenditure_today_s) }} ₭</h5>
                <p>ລາຍຈ່າຍມື້ນີ້</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6">
            <div class="small-box income-box-pro bg-none">
              <div class="bg-warning rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_expenditure_this_month_s) }} ₭</h5>
                <p>ລາຍຈ່າຍເດືອນນີ້</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6">
            <div class="small-box income-box-pro bg-none">
              <div
                class="rounded-top w-100 py-1"
                style="background-color: #54c392"
              ></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_income_this_month_s) }} ₭</h5>
                <p>ລາຍຮັບເດືອນນີ້</p>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-3 col-6">

            <div class="small-box income-box-pro bg-none">
              <div class="bg-warning rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_income_this_month_s) }} ₭</h5>
                <p>ເອົາໃຫ້ແມ່ທັງໝົດ</p>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-lg-3 col-6">

            <div class="small-box income-box-pro bg-none">
              <div class="bg-warning rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_expenditure_to_wife_s) }} ₭</h5>
                <p>ເອົາໃຫ້ໄມທັງໝົດ</p>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-lg-3 col-6">

            <div class="small-box income-box-pro bg-none">
              <div class="bg-success rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_income_by_brother_s) }} ₭</h5>
                <p>ເອົານ້ອງຊາຍເອົາໃຫ້ທັງໝົດ</p>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-lg-3 col-6">

            <div class="small-box income-box-pro bg-none">
              <div class="bg-info rounded-top w-100 py-1"></div>

              <div class="d-flex justify-content-end">
                <div class="currency-circle mt-2 px-2 mx-2">₭</div>
              </div>

              <div class="inner">
                <h5>{{ formatNumber(sum_income_by_salary_s) }} ₭</h5>
                <p>ເງິນເດືອນທັງໝົດ</p>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-sm-3 col-md-3">
            <div class="info-box">
              <span class="info-box-icon bg-info elevation-1"
                ><i class="fas fa-book"></i
              ></span>

              <div class="info-box-content">
                <span class="info-box-text">ໜ້າວຽກປີນີ້</span>
                <span class="info-box-number">{{ count_plans }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-sm-3 col-md-3">
            <div class="info-box mb-3">
              <span class="info-box-icon bg-danger elevation-1"
                ><i class="fas fa-book"></i
              ></span>

              <div class="info-box-content">
                <span class="info-box-text">ໜ້າວຽກປີນີ້ທີ່ຍັງບໍ່ໄດ້ເລີ່ມ</span>
                <span class="info-box-number">{{
                  count_plan_not_yet_successes
                }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->

          <!-- fix for small devices only -->

          <div class="col-sm-3 col-md-3">
            <div class="info-box mb-3">
              <span class="info-box-icon bg-warning elevation-1"
                ><i class="fas fa-book"></i
              ></span>

              <div class="info-box-content">
                <span class="info-box-text">ໜ້າວຽກປີນີ້ສຳເລັດແລ້ວ</span>
                <span class="info-box-number">{{ count_plan_successes }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
          <div class="col-sm-3 col-md-3">
            <div class="info-box mb-3">
              <span
                class="info-box-icon elevation-1 text-white"
                style="background-color: #54c392"
                ><i class="fas fa-calendar-day"></i
              ></span>

              <div class="info-box-content">
                <span class="info-box-text">ຈຳນວນມື້</span>
                <span class="info-box-number">{{ count_days }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
          <!-- /.col -->
        </div>

        <!-- /.row -->
        <!-- Main row -->
        <div class="row">
          <div class="col-md-6">
            <!-- AREA CHART -->

            <!-- /.card -->

            <!-- DONUT CHART -->
            <div class="card">
              <div class="card-header" style="background-color: #54c392">
                <h3 class="card-title text-white">Donut Chart</h3>
              </div>
              <div class="card-body">
                <canvas
                  id="donutChart"
                  style="
                    min-height: 250px;
                    height: 250px;
                    max-height: 250px;
                    max-width: 100%;
                  "
                ></canvas>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->

            <!-- /.card -->
          </div>
          <!-- /.col (LEFT) -->
          <div class="col-md-6">
            <!-- LINE CHART -->
            <!-- <div class="overflow-auto">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>ລະຫັດ</th>
                    <th>ໜ້າວຽກປີນີ້</th>
                    <th>ເປີເຊັນ</th>
                    <th>ການເຄື່ອນໄຫວ</th>
                    <th>ສະຖານະ</th>
                    <th>ເວລາວັນທີ</th>
                    <th>ປຸ່ມຄຳສັ່ງ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(plan, index) in plans" :key="plan.id">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <b class="text-primary">{{ plan.plan_name }}</b>
                    </td>
                    <td>
                      <b class="text-success">{{ plan.percent }} %</b>
                    </td>
                    <td>
                      <b class="text-danger">{{ plan.active }} %</b>
                    </td>
                    <td
                      :class="
                        plan.status === 0 ? 'text-danger' : 'text-success'
                      "
                    >
                      <b>{{
                        plan.status === 0 ? "ຍັງບໍ່ໄດ້ເລີ່ມ" : "ສຳເລັດແລ້ວ"
                      }}</b>
                    </td>
                    <td>
                      <b class="text-success">{{ plan.timestamp }}</b>
                    </td>
                    <td>
                      <button
                        @click="confirmDelete_a(plan.id)"
                        class="btn btn-danger"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> -->
            <div class="card card-danger">
              <div class="card-header">
                <h3 class="card-title">Bar Chart</h3>

                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="chart">
                  <canvas
                    id="barChart"
                    style="
                      min-height: 250px;
                      height: 250px;
                      max-height: 250px;
                      max-width: 100%;
                    "
                  ></canvas>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
            <!-- STACKED BAR CHART -->

            <!-- /.card -->
          </div>
          <!-- /.col (RIGHT) -->
        </div>
        <div class="row">
          <div class="col-md-6">
            <!-- /.card -->
            <h3 class="text-center text-bold" style="color: #54c392">
              ລາຍຮັບທັງໝົດ
            </h3>
            <div class="justify-content-between d-flex">
              <!-- <a
                href="#"
                class="btn btn-success"
                data-toggle="modal"
                data-target="#modal-insertincome"
                ><i class="fas fa-plus mr-2"></i>ເພີ່ມລາຍຮັບ</a
              > -->
              <!-- <router-linkິ
                  to="/print_income"
                  class="btn btn-success"
                  data-toggle="modal"
                  data-target="#modal-insertincome"
                  ><i class="fas fa-print mr-2"></i>Print PDF</router-linkິ
                > -->
            </div>
            <div class="overflow-auto">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>ລະຫັດ</th>
                    <th>ຈຳນວນເງິນ</th>
                    <th>ເຫດຜົນ</th>
                    <th>ສະຖານະ</th>
                    <th>ເວລາວັນທີ</th>
                    <th>ປຸ່ມຄຳສັ່ງ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(income_s, index) in incomes_s" :key="income_s.id">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <b style="color: #54c392"
                        >{{ formatNumber(income_s.income) }}₭</b
                      >
                    </td>
                    <td>
                      <b>{{ income_s.income_reason }}</b>
                    </td>
                    <td>
                      <b style="color: #54c392">{{ income_s.m_status }}</b>
                    </td>
                    <td>
                      <b style="color: #54c392">{{ income_s.timestamp }}</b>
                    </td>
                    <td>
                      <!-- <button
                        href="#"
                        class="btn btn-warning"
                        data-toggle="modal"
                        @click="fetchIncomeDetails(income_s.id)"
                        data-target="#modal-lg"
                      >
                        <i class="fas fa-edit"></i></button
                      >&nbsp; -->
                      <button
                        @click="confirmDeleteIncome_a(income_s.id)"
                        class="btn btn-danger"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-6">
            <!-- /.card -->
            <h3 class="text-center text-bold text-danger">ລາຍຈ່າຍທັງໝົດ</h3>
            <div class="justify-content-between d-flex">
              <!-- <a
                href="#"
                class="btn btn-danger"
                data-toggle="modal"
                data-target="#modal-insertexpenditure"
                ><i class="fas fa-plus mr-2"></i>ເພີ່ມລາຍຈ່າຍ</a
              > -->
              <!-- <router-link
                  to="/print_expenditure"
                  class="btn btn-danger"
                  data-toggle="modal"
                  data-target="#modal-insertexpenditure"
                  ><i class="fas fa-print mr-2"></i>Print PDF</router-link
                > -->
            </div>
            <div class="overflow-auto">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>ລະຫັດ</th>
                    <th>ຈຳນວນເງິນ</th>
                    <th>ເຫດຜົນ</th>
                    <th>ສະຖານະ</th>
                    <th>ເວລາວັນທີ</th>
                    <th>ປຸ່ມຄຳສັ່ງ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(expenditure_s, index) in expenditures_s"
                    :key="expenditure_s.id"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <b class="text-danger"
                        >{{ formatNumber(expenditure_s.expenditure) }}₭</b
                      >
                    </td>
                    <td>
                      <b>{{ expenditure_s.expenditure_reason }}</b>
                    </td>
                    <td>
                      <b class="text-danger">{{ expenditure_s.m_status }}</b>
                    </td>
                    <td>
                      <b style="color: #54c392">{{
                        expenditure_s.timestamp
                      }}</b>
                    </td>
                    <td>
                      <!-- <button
                        href="#"
                        class="btn btn-warning"
                        data-toggle="modal"
                        @click="fetchExpenditureDetails(expenditure_s.id)"
                        data-target="#modal-editexpenditure"
                      >
                        <i class="fas fa-edit"></i></button
                      >&nbsp; -->
                      <button
                        @click="confirmDeleteExpenditure_a(expenditure_s.id)"
                        class="btn btn-danger"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card p-3">
              <h5 class="text-center mb-3">ລາຍຮັບ ແລະ ລາຍຈ່າຍປີ (2026)</h5>

              <div>
                <div class="card-body">
                  <div style="height: 300px">
                    <canvas ref="lineChart"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card p-3">
              <h5 class="text-center mb-3">
                ລາຍຮັບ ແລະ ລາຍຈ່າຍເດືອນ {{ this_month_parameter }} ປີ
                {{ this_year_parameter }}
              </h5>

              <div>
                <div class="card-body">
                  <div style="height: 300px">
                    <canvas ref="bar1Chart"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" style="overflow: auto">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>5:00-6:00</th>
                  <th>6:00-7:00</th>
                  <th>7:00-8:00</th>
                  <th>8:00-9:00</th>
                  <th>9:00-10:00</th>
                  <th>10:00-11:00</th>
                  <th>11:00-12:00</th>
                  <th>12:00-13:00</th>
                  <th>13:00-14:00</th>
                  <th>14:00-15:00</th>
                  <th>15:00-16:00</th>
                  <th>16:00-17:00</th>
                  <th>17:00-18:00</th>
                  <th>18:00-19:00</th>
                  <th>19:00-20:00</th>
                  <th>20:00-21:00</th>
                  <th>21:00-22:00</th>
                  <th>22:00-23:00</th>
                  <th>23:00-5:00</th>
                  <th>ມື້ວັນ</th>
                  <th>ວັນທີ່ & ເວລາ</th>
                  <th>ປຸ່ມຄຳສັ່ງ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(daily_d, index) in dailies_d" :key="daily_d.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ daily_d.five_six }}</td>
                  <td>{{ daily_d.six_seven }}</td>
                  <td>{{ daily_d.seven_eight }}</td>
                  <td>{{ daily_d.eight_nine }}</td>
                  <td>{{ daily_d.nine_ten }}</td>
                  <td>{{ daily_d.ten_eleven }}</td>
                  <td>{{ daily_d.eleven_twelve }}</td>
                  <td>{{ daily_d.twelve_thirteen }}</td>
                  <td>{{ daily_d.thirteen_fourteen }}</td>
                  <td>{{ daily_d.fourteen_fifteen }}</td>
                  <td>{{ daily_d.fifteen_sixteen }}</td>
                  <td>{{ daily_d.sixteen_seventeen }}</td>
                  <td>{{ daily_d.seventeen_eighteen }}</td>
                  <td>{{ daily_d.eighteen_nineteen }}</td>
                  <td>{{ daily_d.nineteen_twenty }}</td>
                  <td>{{ daily_d.twenty_twentyone }}</td>
                  <td>{{ daily_d.twentyone_twentytwo }}</td>
                  <td>{{ daily_d.twentytwo_twentythree }}</td>
                  <td>{{ daily_d.twentythree_five }}</td>
                  <td>{{ daily_d.days }}</td>
                  <td>
                    <b style="color: #54c392">{{ daily_d.timestamp }}</b>
                  </td>
                  <td>
                    <!-- <button
                        href="#"
                        class="btn btn-warning"
                        data-toggle="modal"
                        @click="fetchDailyDetails(daily_d.id)"
                        data-target="#modal-lg"
                      >
                        <i class="fas fa-edit"></i></button
                      >&nbsp; -->
                    <button
                      @click="confirmDelete_d(daily_d.id)"
                      class="btn btn-danger"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.row (main row) -->
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import flatpickr from "flatpickr";
import Swal from "sweetalert2";
import axios from "axios";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
export default {
  name: "HomeComponent",
  props: {
    plan: Object,
  },
  computed: {
    statusClass() {
      return this.plan.status === 0 ? "text-danger" : "text-success";
    },
    statusText() {
      return this.plan.status === 0 ? "not success" : "success";
    },
  },
  data() {
    return {
      five_six_d: "",
      six_seven_d: "",
      seven_eight_d: "",
      eight_nine_d: "",
      nine_ten_d: "",
      ten_eleven_d: "",
      eleven_twelve_d: "",
      twelve_thirteen_d: "",
      thirteen_fourteen_d: "",
      fourteen_fifteen_d: "",
      fifteen_sixteen_d: "",
      sixteen_seventeen_d: "",
      seventeen_eighteen_d: "",
      eighteen_nineteen_d: "",
      nineteen_twenty_d: "",
      twenty_twentyone_d: "",
      twentyone_twentytwo_d: "",
      twentytwo_twentythree_d: "",
      twentythree_five_d: "",
      day_d: "",
      Daily_ID: null,
      dailies_d: [],
      count_plans: 0,
      count_plan_successes: 0,
      count_plan_not_yet_successes: 0,
      count_days: 0,
      sum_incomes: 0,
      sum_expenditures: 0,
      sum_money_remainings: 0,
      sum_money_remaining_dollars: 0,
      sum_expenditure_today_s: 0,
      sum_income_this_month_s: 0,
      sum_expenditure_this_month_s: 0,
      sum_income_by_month_s: 0,
      income_inp: "",
      income_reason_inp: "",
      expenditure_inp: "",
      expenditure_reason_inp: "",
      m_status_inp: "",
      income_upd: "",
      income_reason_upd: "",
      expenditure_upd: "",
      expenditure_reason_upd: "",
      m_status_upd: "",
      Income_ID: null,
      Expenditure_ID: null,
      incomes_s: [],
      expenditures_s: [],
      chart: null, // Store chart instance
      lineChart: null,
      bar1Chart: null,
      this_year_parameter: new Date().getFullYear(),
      this_month_parameter: new Date().getMonth() + 1,

      Plan_name_inp: "",
      percent_inp: "",
      areaChartData: {
        labels: ["January", "February", "March", "April"],
        datasets: [
          {
            label: "ລາຍຮັບ",
            // income
            backgroundColor: "#00a65a",
            data: [this.sum_income_this_month_s],
          },
          {
            label: "ລາຍຈ່າຍ",
            // expenditure
            backgroundColor: "#f56954",
            data: [this.sum_expenditure_this_month_s],
          },
        ],
      },
      startDate: new Date().toISOString().substr(0, 10), // today
      endDate: new Date().toISOString().substr(0, 10), // today
    };
  },
  created() {
    this.fetchDaily_d();
    this.fetchIncome_s();
    this.fetchExpenditure_s();
    this.fetchPlans();
  },
  mounted() {
    this.fetchCountPlan();
    this.fetchCountPlanSuccess();
    this.fetchCountPlanNotYetSuccess();
    this.fetchCountDay();
    this.fetchSumIncome();
    this.fetchSumExpenditure();
    this.fetchSumMoneyRemaining();
    this.fetchSumMoneyRemainingDollar();
    this.fetchSumExpenditureToday();
    // this.fetchSumExpenditureToWife();
    this.fetchSumIncomeByBrother();
    this.fetchSumIncomeThisMonth();
    this.fetchSumExpenditureThisMonth();
    this.fetchSumIncomeByMom();
    // this.fetchSumExpenditureToMom();
    this.fetchSumIncomeBySalary();
    // this.fetchChartData();
    // this.renderChart();
    this.fetchDataAndRenderChart();
    this.renderBarChart();
    flatpickr("#startDate", {
      dateFormat: "Y-m-d",
      onChange: (selectedDates, dateStr) => {
        this.startDate = dateStr;
      },
    });
    flatpickr("#endDate", {
      dateFormat: "Y-m-d",
      onChange: (selectedDates, dateStr) => {
        this.endDate = dateStr;
      },
    });
    this.$nextTick(() => {
      this.fetchChartData();
      this.fetchBarChartData();
    });
  },
  watch: {
    sum_incomes() {
      this.renderChart();
    },
    sum_expenditures() {
      this.renderChart();
      this.renderBarChart();
    },
    sum_money_remainings() {
      this.renderChart();
    },
    sum_income_this_month_s() {
      this.renderBarChart();
    },
    sum_expenditure_this_month_s() {
      this.renderBarChart();
    },
    sum_income_today_s() {
      this.renderBarChart();
    },
    sum_expenditure_today_s() {
      this.renderBarChart();
    },
  },
  methods: {
    async fetchChartData() {
      try {
        const res = await axios.get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/income-expenditure-by-month?year=2026"
        );

        this.renderLineChart(
          res.data.months,
          res.data.income,
          res.data.expenditure
        );
      } catch (error) {
        console.error("Error loading chart:", error);
      }
    },

    async fetchBarChartData() {
      try {
        const res = await axios.get(
          `https://nodejs-api-daily-porchoua-4.onrender.com/api/income-expenditure-by-date?year=${this.this_year_parameter}&month=${this.this_month_parameter}`
        );

        this.renderBar1Chart(
          res.data.dates, // ✅ FIX
          res.data.income,
          res.data.expenditure
        );
      } catch (error) {
        console.error("Error loading chart:", error);
      }
    },

    renderLineChart(months, income, expenditure) {
      if (!this.$refs.lineChart) {
        console.error("lineChart canvas not found");
        return;
      }

      if (this.lineChart) {
        this.lineChart.destroy();
      }

      this.lineChart = new Chart(this.$refs.lineChart, {
        type: "line",
        data: {
          labels: months,
          datasets: [
            {
              label: "ລາຍຮັບ",
              data: income,
              borderColor: "#28a745",
              backgroundColor: "rgba(40,167,69,0.2)",
              fill: true,
              tension: 0.4,
            },
            {
              label: "ລາຍຈ່າຍ",
              data: expenditure,
              borderColor: "#dc3545",
              backgroundColor: "rgba(220,53,69,0.2)",
              fill: true,
              tension: 0.4,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: "bottom" },
          },
          scales: {
            y: { beginAtZero: true },
          },
        },
      });
    },
    renderBar1Chart(labels, income, expenditure) {
      if (!this.$refs.bar1Chart) {
        // ✅ FIX
        console.error("bar1Chart canvas not found");
        return;
      }

      if (this.bar1Chart) {
        this.bar1Chart.destroy();
      }

      this.bar1Chart = new Chart(this.$refs.bar1Chart, {
        type: "bar",
        data: {
          labels: labels, // 2025-12-01 ... 2025-12-31
          datasets: [
            {
              label: "ລາຍຮັບ",
              data: income,
              backgroundColor: "rgba(40,167,69,0.7)",
              borderRadius: 6,
            },
            {
              label: "ລາຍຈ່າຍ",
              data: expenditure,
              backgroundColor: "rgba(220,53,69,0.7)",
              borderRadius: 6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: "bottom" },
            tooltip: {
              callbacks: {
                label: (ctx) =>
                  `${ctx.dataset.label}: ${ctx.parsed.y.toLocaleString()} ₭`,
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => value.toLocaleString(),
              },
            },
          },
        },
      });
    },
    handleSearch() {
      this.fetchSumIncome();
      this.fetchSumExpenditure();
    },
    formatNumber(value) {
      if (!value) return "0";
      return Number(value).toLocaleString("en-US");
    },
    async fetchPlans() {
      try {
        const response = await axios.get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/plan"
        );
        if (Array.isArray(response.data)) {
          this.plans = response.data;
        } else {
          console.error("Invalid response format:", response.data);
          this.showErrorMessage();
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
        this.showErrorMessage();
      }
    },
    async confirmDelete_a(Plan_ID) {
      Swal.fire({
        title: "ຕ້ອງການລຶບແທ້ ຫຼື ບໍ່?",
        text: "ທ່ານແນ່ໃຈບໍ ທີ່ຈະລຶບລະຫັດທີ່: " + Plan_ID,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "ຍົກເລີກ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ຢືນຢັນ!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletePlan(Plan_ID);
        }
      });
    },

    async deletePlan(Plan_ID) {
      try {
        const response = await axios.delete(
          `https://nodejs-api-daily-porchoua-4.onrender.com/api/delete-plan/${Plan_ID}`
        );
        console.log(response.data); // Log the response from the server
        Swal.fire({
          title: "ລົບລ້າງສຳເລັດ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບສຳເລັດແລ້ວ",
          icon: "success",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        }).then(() => {
          this.fetchPlans(); // Fetch updated employee list
          // this.fetchForm(); // Reset the employee form
        });
        // Optionally, you can perform additional actions after successful deletion
      } catch (error) {
        console.error("Error deleting employee:", error);
        Swal.fire({
          title: "ລົບລ້າງສຳເລັດ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບສຳເລັດແລ້ວ",
          icon: "error",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        });
        // Show error message
      }
    },
    async fetchDaily_d() {
      try {
        const response = await axios.get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/daily"
        );
        if (Array.isArray(response.data)) {
          this.dailies_d = response.data;
        } else {
          console.error("Invalid response format:", response.data);
          this.showErrorMessage();
        }
      } catch (error) {
        console.error("Error fetching daily:", error);
        this.showErrorMessage();
      }
    },
    async createDaily_d() {
      try {
        const response = await axios.post(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/create-admin",
          {
            five_six: this.five_six_d,
            six_seven: this.six_seven_d,
            seven_eight: this.seven_eight_d,
            eight_nine: this.eight_nine_d,
            nine_ten: this.nine_ten_d,
            ten_eleven: this.ten_eleven_d,
            eleven_twelve: this.eleven_twelve_d,
            twelve_thirteen: this.twelve_thirteen_d,
            thirteen_fourteen: this.thirteen_fourteen_d,
            fourteen_fifteen: this.fourteen_fifteen_d,
            fifteen_sixteen: this.fifteen_sixteen_d,
            sixteen_seventeen: this.sixteen_seventeen_d,
            seventeen_eighteen: this.seventeen_eighteen_d,
            eighteen_nineteen: this.eighteen_nineteen_d,
            nineteen_twenty: this.nineteen_twenty_d,
            twenty_twentyone: this.twenty_twentyone_d,
            twentyone_twentytwo: this.twentyone_twentytwo_d,
            twentytwo_twentythree: this.twentytwo_twentythree_d,
            twentythree_five: this.twentythree_five_d,
            days: this.day_d,
            timestamp: this.timestamp,
          }
        );
        console.log(response.data);
        // alert('Employee added successfully');
        this.showSuccessMessage();
        // Optionally, you can fetch the updated list of sale employees after adding a new employee
        this.fetchDaily_d();

        this.resetDaily_d_Form();
      } catch (error) {
        console.error("Error creating employee:", error);
        // alert('Failed to create employee');
        this.showErrorMessage();
      }
    },

    // create Employee Machinist

    async resetDaily_d_Form() {
      // Reset all form fields to their initial state
      (this.five_six_d = ""),
        (this.six_seven_d = ""),
        (this.seven_eight_d = ""),
        (this.eight_nine_d = ""),
        (this.nine_ten_d = ""),
        (this.ten_eleven_d = ""),
        (this.eleven_twelve_d = ""),
        (this.twelve_thirteen_d = ""),
        (this.thirteen_fourteen_d = ""),
        (this.fourteen_fifteen_d = ""),
        (this.fifteen_sixteen_d = ""),
        (this.sixteen_seventeen_d = ""),
        (this.seventeen_eighteen_d = ""),
        (this.eighteen_nineteen_d = ""),
        (this.nineteen_twenty_d = ""),
        (this.twenty_twentyone_d = ""),
        (this.twentyone_twentytwo_d = ""),
        (this.twentytwo_twentythree_d = ""),
        (this.twentythree_five_d = ""),
        (this.day_d = "");
    },

    // function delete employee sale
    async confirmDelete_d(Daily_ID) {
      Swal.fire({
        title: "ຕ້ອງການລຶບແທ້ ຫຼື ບໍ່?",
        text: "ທ່ານແນ່ໃຈບໍ ທີ່ຈະລຶບລະຫັດທີ່: " + Daily_ID,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "ຍົກເລີກ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ຢືນຢັນ!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteDaily_d(Daily_ID);
        }
      });
    },

    async deleteDaily_d(Daily_ID) {
      try {
        const response = await axios.delete(
          `https://nodejs-api-daily-porchoua-4.onrender.com/api/delete-daily/${Daily_ID}`
        );
        console.log(response.data); // Log the response from the server
        Swal.fire({
          title: "ລົບລ້າງ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບສຳເລັດແລ້ວ",
          icon: "success",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        }).then(() => {
          this.fetchDaily_d(); // Fetch updated employee list
          this.resetDaily_d_Form(); // Reset the employee form
        });
        // Optionally, you can perform additional actions after successful deletion
      } catch (error) {
        console.error("Error deleting employee:", error);
        Swal.fire({
          title: "ລົບລ້າງ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບສຳເລັດແລ້ວ",
          icon: "error",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        });
        // Show error message
      }
    },

    // function delete employee machinist

    async showSuccessMessage() {
      Swal.fire({
        title: "ບັນທຶກສຳເລັດ",
        text: "ຂໍ້ມູນໄດ້ຖືກບັນທຶກສຳເລັດແລ້ວ",
        icon: "success",
        timer: 2000, // 2-3 seconds
        position: "top-end", // Position the success message to top-right
        toast: true, // Optional: makes it a toast notification
        showConfirmButton: false, // Optional: removes the "OK" button
      });
    },
    async showUpdateSuccessMessage() {
      Swal.fire({
        title: "ແກ້ໄຂສຳເລັດ",
        text: "ຂໍ້ມູນໄດ້ຖືກແກ້ໄຂສຳເລັດແລ້ວ",
        icon: "success",
        timer: 2000, // 2-3 seconds
        position: "top-end", // Position the success message to top-right
        toast: true, // Optional: makes it a toast notification
        showConfirmButton: false, // Optional: removes the "OK" button
      });
    },
    async showErrorMessage() {
      Swal.fire({
        title: "ເກີດຂໍ້ຜິດພາດ",
        text: "ກະລຸນາກວດສອບອີກຄັ້ງ!",
        icon: "warning",
        timer: 2000, // 2-3 seconds
        position: "top-end", // Position the success message to top-right
        toast: true, // Optional: makes it a toast notification
        showConfirmButton: false, // Optional: removes the "OK" button
      });
    },
    async fetchDailyDetails(Daily_ID) {
      this.Daily_ID = Daily_ID; // Set the current category ID
      try {
        const response = await axios.get(
          `https://nodejs-api-daily-porchoua-4.onrender.com/api/daily/${Daily_ID}`
        );
        this.updatedName = response.data.name; // Set the existing category name to the input field
        this.updatedemail = response.data.email;
        this.updatedpassword = "";
        this.updatedphone = response.data.phone;
      } catch (error) {
        console.error(error.response.data);
        // Handle error (e.g., show error message)
      }
    },

    async fetchCountPlan() {
      axios
        .get("https://nodejs-api-daily-porchoua-4.onrender.com/api/count-plan")
        .then((response) => {
          this.count_plans = response.data.count_plan;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },

    async fetchCountPlanSuccess() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/count-plan_success"
        )
        .then((response) => {
          this.count_plan_successes = response.data.count_plan_success;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },

    async fetchCountPlanNotYetSuccess() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/count-plan_not_yet_success"
        )
        .then((response) => {
          this.count_plan_not_yet_successes =
            response.data.count_plan_not_yet_success;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchCountDay() {
      axios
        .get("https://nodejs-api-daily-porchoua-4.onrender.com/api/count-days")
        .then((response) => {
          this.count_days = response.data.count_days;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchSumIncome() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/sum-income",
          {
            params: {
              startDate: this.startDate,
              endDate: this.endDate,
            },
          }
        )
        .then((response) => {
          this.sum_incomes = response.data.sum_income || 0;
        })
        .catch((error) => {
          console.error("There was an error fetching the sum income:", error);
        });
    },
    async fetchSumExpenditure() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-expenditure",
          {
            params: {
              startDate: this.startDate,
              endDate: this.endDate,
            },
          }
        )
        .then((response) => {
          this.sum_expenditures = response.data.sum_expenditure || 0;
        })
        .catch((error) => {
          console.error("There was an error fetching the sum income:", error);
        });
    },
    async fetchSumMoneyRemaining() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-money_remaining"
        )
        .then((response) => {
          this.sum_money_remainings = response.data.sum_money_remaining;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchSumMoneyRemainingDollar() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-money_remaining_dollar"
        )
        .then((response) => {
          this.sum_money_remaining_dollars =
            response.data.sum_money_remaining_dollar;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchDataAndRenderChart() {
      await Promise.all([
        this.fetchSumIncome(),
        this.fetchSumExpenditure(),
        this.fetchSumMoneyRemaining(),
      ]);
      this.renderChart();
    },
    renderChart() {
      if (this.chart) {
        this.chart.destroy(); // Destroy previous chart instance if exists
      }

      const ctx = document.getElementById("donutChart").getContext("2d");
      this.chart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["ລາຍຮັບ", "ລາຍຈ່າຍ", "ເງິນທີ່ຍັງເຫຼືອ"],
          datasets: [
            {
              data: [
                this.sum_incomes,
                this.sum_expenditures,
                this.sum_money_remainings,
              ],
              backgroundColor: ["#54c392", "#f56954", "#f39c12"],
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
        },
      });
    },
    renderBarChart() {
      const ctx = document.getElementById("barChart");
      if (ctx) {
        if (window.barChartInstance) {
          window.barChartInstance.destroy();
        }

        window.barChartInstance = new Chart(ctx, {
          type: "bar",
          data: {
            labels: ["ປີນີ້", "ເດືອນນີ້", "ມື້ນີ້"],
            datasets: [
              {
                label: "ລາຍຮັບ",
                backgroundColor: "#54c392",
                data: [
                  this.sum_incomes,
                  this.sum_income_this_month_s,
                  this.sum_income_today_s,
                ],
              },
              {
                label: "ລາຍຈ່າຍ",
                backgroundColor: "#f56954",
                data: [
                  this.sum_expenditures,
                  this.sum_expenditure_this_month_s,
                  this.sum_expenditure_today_s,
                ],
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      } else {
        console.warn("Canvas not found");
      }
    },

    async fetchSumExpenditureToday() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-expenditure_todays"
        )
        .then((response) => {
          this.sum_expenditure_today_s = response.data.sum_expenditure_todays;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchSumIncomeThisMonth() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-income_this_month"
        )
        .then((response) => {
          this.sum_income_this_month_s = response.data.sum_income_this_month;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },

    async fetchSumExpenditureThisMonth() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-expenditure_this_month"
        )
        .then((response) => {
          this.sum_expenditure_this_month_s =
            response.data.sum_expenditure_this_month;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchSumIncomeByMom() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-income_by_mom"
        )
        .then((response) => {
          this.sum_income_by_mom_s = response.data.sum_income_by_mom;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    // async fetchSumExpenditureToMom() {
    //   axios
    //     .get("https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-expenditure_to_mom")
    //     .then((response) => {
    //       this.sum_expenditure_to_mom_s = response.data.sum_expenditure_to_mom;
    //     })
    //     .catch((error) => {
    //       console.error("There was an error fetching the count:", error);
    //     });
    // },
    // async fetchSumExpenditureToWife() {
    //   axios
    //     .get("https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-expenditure_to_wife")
    //     .then((response) => {
    //       this.sum_expenditm_expenditure_to_wife_s =
    //         response.data.sum_expenditure_to_wife;
    //     })
    //     .catch((error) => {
    //       console.error("There was an error fetching the count:", error);
    //     });
    // },
    async fetchSumIncomeByBrother() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-income_by_brother"
        )
        .then((response) => {
          this.sum_income_by_brother_s = response.data.sum_income_by_brother;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchSumIncomeBySalary() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/sum-income_by_salary"
        )
        .then((response) => {
          this.sum_income_by_salary_s = response.data.sum_income_by_salary;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },
    async fetchIncome_s() {
      try {
        const response = await axios.get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/income"
        );
        if (Array.isArray(response.data)) {
          this.incomes_s = response.data;
        } else {
          console.error("Invalid response format:", response.data);
          this.showErrorMessage();
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
        this.showErrorMessage();
      }
    },

    async fetchExpenditure_s() {
      try {
        const response = await axios.get(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/expenditure"
        );
        if (Array.isArray(response.data)) {
          this.expenditures_s = response.data;
        } else {
          console.error("Invalid response format:", response.data);
          this.showErrorMessage();
        }
      } catch (error) {
        console.error("Error fetching expenditure:", error);
        this.showErrorMessage();
      }
    },

    async createIncome() {
      try {
        const response = await axios.post(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/create-income",
          {
            income: this.income_inp,
            income_reason: this.income_reason_inp,
            m_status: this.m_status_inp,
            timestamp: this.timestamp,
          }
        );
        console.log(response.data);
        // alert('Employee added successfully');
        this.showSuccessMessage();
        // Optionally, you can fetch the updated list of sale employees after adding a new employee
        this.fetchIncome_s();
        this.resetIncome_s_Form();
      } catch (error) {
        console.error("Error creating employee:", error);
        // alert('Failed to create employee');
        this.showErrorMessage();
      }
    },

    async createExpenditure() {
      try {
        const response = await axios.post(
          "https://nodejs-api-daily-porchoua-6.onrender.com/api/create-expenditure",
          {
            expenditure: this.expenditure_inp,
            expenditure_reason: this.expenditure_reason_inp,
            m_status: this.m_status_inp,
            timestamp: this.timestamp,
          }
        );
        console.log(response.data);
        // alert('Employee added successfully');
        this.showSuccessMessage();
        // Optionally, you can fetch the updated list of sale employees after adding a new employee
        this.fetchExpenditure_s();
        this.resetExpenditure_s_Form();
      } catch (error) {
        console.error("Error creating employee:", error);
        // alert('Failed to create employee');
        this.showErrorMessage();
      }
    },

    // create Employee Machinist

    async resetIncome_s_Form() {
      // Reset all form fields to their initial state
      this.income_inp = "";
      this.income_reason_inp = "";
      this.m_status_inp = "";
    },

    async resetExpenditure_s_Form() {
      // Reset all form fields to their initial state
      this.expenditure_inp = "";
      this.expenditure_reason_inp = "";
      this.m_status_inp = "";
    },

    // function delete employee sale
    async confirmDeleteIncome_a(Income_Id) {
      Swal.fire({
        title: "ຕ້ອງການລຶບແທ້ ຫຼື ບໍ່?",
        text: "ທ່ານແນ່ໃຈບໍ ທີ່ຈະລຶບລະຫັດທີ່: " + Income_Id,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "ຍົກເລີກ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ຢືນຢັນ!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteIncome(Income_Id);
        }
      });
    },

    async confirmDeleteExpenditure_a(Expenditure_ID) {
      Swal.fire({
        title: "ຕ້ອງການລຶບແທ້ ຫຼື ບໍ່?",
        text: "ທ່ານແນ່ໃຈບໍ ທີ່ຈະລຶບລະຫັດທີ່: " + Expenditure_ID,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "ຍົກເລີກ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ຢືນຢັນ!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteExpenditure(Expenditure_ID);
        }
      });
    },

    async deleteExpenditure(Expenditure_ID) {
      try {
        const response = await axios.delete(
          `https://nodejs-api-daily-porchoua-6.onrender.com/api/delete-daily/${Expenditure_ID}`
        );
        console.log(response.data); // Log the response from the server
        Swal.fire({
          title: "ລົບລ້າງສຳເລັດ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບສຳເລັດແລ້ວ",
          icon: "success",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        }).then(() => {
          this.fetchExpenditure_s(); // Fetch updated employee list
          this.resetExpenditure_s_Form(); // Reset the employee form
        });
        // Optionally, you can perform additional actions after successful deletion
      } catch (error) {
        console.error("Error deleting employee:", error);
        Swal.fire({
          title: "ລົບລ້າງບໍ່ສຳເລັດ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບບໍ່ສຳເລັດແລ້ວ",
          icon: "error",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        });
        // Show error message
      }
    },

    async deleteIncome(Income_Id) {
      try {
        const response = await axios.delete(
          `https://nodejs-api-daily-porchoua-6.onrender.com/api/delete-daily/${Income_Id}`
        );
        console.log(response.data); // Log the response from the server
        Swal.fire({
          title: "ລົບລ້າງສຳເລັດ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບສຳເລັດແລ້ວ",
          icon: "success",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        }).then(() => {
          this.fetchIncome_s(); // Fetch updated employee list
          this.resetIncome_s_Form(); // Reset the employee form
        });
        // Optionally, you can perform additional actions after successful deletion
      } catch (error) {
        console.error("Error deleting employee:", error);
        Swal.fire({
          title: "ລົບລ້າງບໍ່ສຳເລັດ!",
          text: "ຂໍ້ມູນໄດ້ຖືກລຶບບໍ່ສຳເລັດແລ້ວ",
          icon: "error",
          timer: 2000, // 2-3 seconds
          position: "top-end", // Position the success message to top-right
          toast: true, // Optional: makes it a toast notification
          showConfirmButton: false, // Optional: removes the "OK" button
        });
        // Show error message
      }
    },

    // Other methods...
  },
};
</script>
